module.exports = __webpack_public_path__ + "static/media/circle-spin-purple.1f087b7e.svg";